// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "world.qoin",
    name: "Qoin Wallet",
    homepage: "https://qoin.world",
    image_id: "0490da30-b59c-4365-fef8-33a3e0aa4700",
    app: {
        browser: null,
        ios: "https://apps.apple.com/au/app/qoin-wallet/id1483718254",
        android: "https://play.google.com/store/apps/details?id=com.qoin.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "wcqoin://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map